export default __webpack_public_path__ + "static/media/arrow.797c1e05.svg";